'use strict';

var isActive = require('./is-active.cjs');

function setDragLock(axis) {
    if (axis === "x" || axis === "y") {
        if (isActive.isDragging[axis]) {
            return null;
        }
        else {
            isActive.isDragging[axis] = true;
            return () => {
                isActive.isDragging[axis] = false;
            };
        }
    }
    else {
        if (isActive.isDragging.x || isActive.isDragging.y) {
            return null;
        }
        else {
            isActive.isDragging.x = isActive.isDragging.y = true;
            return () => {
                isActive.isDragging.x = isActive.isDragging.y = false;
            };
        }
    }
}

exports.setDragLock = setDragLock;
//# sourceMappingURL=set-active.cjs.map
